import { render, staticRenderFns } from "./InventoryProfile.vue?vue&type=template&id=2a1f4860&scoped=true"
import script from "./InventoryProfile.vue?vue&type=script&lang=js"
export * from "./InventoryProfile.vue?vue&type=script&lang=js"
import style0 from "./InventoryProfile.vue?vue&type=style&index=0&id=2a1f4860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f4860",
  null
  
)

export default component.exports